import { render, staticRenderFns } from "./SeagullTermAndCondition.vue?vue&type=template&id=2b324814&scoped=true&"
import script from "./SeagullTermAndCondition.vue?vue&type=script&lang=js&"
export * from "./SeagullTermAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./SeagullTermAndCondition.vue?vue&type=style&index=0&id=2b324814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b324814",
  null
  
)

export default component.exports